import {toSecureCardNumber} from '@logistics-frontend/core/formatters'
import {Optional} from '@logistics-frontend/types'
import {allPass, applySpec, constant, flow, get, ifElse, isNumber, map} from '@logistics-frontend/utils'

import {
  PaymentCard,
  PaymentCardList,
  PaymentMethodDefault,
  PaymentMethodLegacy,
  PaymentMethodsResponse,
} from '../../types'

function getCardNumber(paymentMethod: PaymentMethodDefault) {
  return toSecureCardNumber(paymentMethod.number, paymentMethod.system)
}

function formatToExpirationDate(paymentMethod: PaymentMethodDefault) {
  return `${String(paymentMethod.expiration_month).padStart(2, '0')} / ${paymentMethod.expiration_year}`
}

const hasExpirationMonth = flow(get('expiration_month'), isNumber)

const hasExpirationYear = flow(get('expiration_year'), isNumber)

const getExpirationDate: (paymentMethod: PaymentMethodDefault) => Optional<string> = ifElse(
  allPass([hasExpirationMonth, hasExpirationYear]),
  formatToExpirationDate,
  constant(undefined),
)

const fromDefaultPayment: (paymentMethod: PaymentMethodDefault) => PaymentCard = applySpec<PaymentCard>({
  id: get('card_id'),
  number: getCardNumber,
  rawNumber: get('number'),
  system: get('system'),
  expirationDate: getExpirationDate,
})

const fromLegacyPayment: (paymentMethod: PaymentMethodLegacy) => PaymentCard = applySpec<PaymentCard>({
  id: get('id'),
  number: getCardNumber,
  rawNumber: get('number'),
  system: get('system'),
  expirationDate: getExpirationDate,
})

function toCardItem(payment: PaymentMethodDefault | PaymentMethodLegacy): PaymentCard {
  return 'card_id' in payment ? fromDefaultPayment(payment) : fromLegacyPayment(payment)
}

export const toPaymentCards: (response: PaymentMethodsResponse) => PaymentCardList = flow(
  get('available_cards'),
  map(toCardItem),
)
